import {z}from'zod';const e=z.object({filter:z.record(z.string(),z.array(z.string()))});export{e as AttendantFilteredKeysSchema};